import { Box, CircularProgress, styled, Typography } from '@mui/material';
import { Column } from 'components/Layout';

const Centered = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'fullHeight',
})<{ fullHeight?: boolean }>(({ fullHeight }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  minHeight: 400,
  ...(fullHeight && { height: '100%' }),
}));

const DarkCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.grey[900],
}));

type Props = {
  title?: string;
  subtitle?: string;
  fullHeight?: boolean;
};

const ProcessingPage: React.FC<Props> = ({ title, subtitle, fullHeight }) => {
  return (
    <Centered fullHeight={fullHeight}>
      <Column spacing="lg" centered>
        <DarkCircularProgress size={40} />
        <Column spacing="xs" centered>
          {title ? (
            <Typography variant="h4" align="center">
              {title}
            </Typography>
          ) : null}
          {subtitle ? (
            <Typography variant="body2" color="text.secondary" align="center">
              {subtitle}
            </Typography>
          ) : null}
        </Column>
      </Column>
    </Centered>
  );
};

export default ProcessingPage;
